import { defineComponent as _defineComponent } from 'vue';
import { BButton } from "bootstrap-vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faShareAlt, faGlobe, faLink } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SharingIndicators',
    props: {
        object: null
    },
    setup(__props) {
        const props = __props;
        library.add(faGlobe, faShareAlt, faLink);
        return { __sfc: true, props, BButton, FontAwesomeIcon };
    }
});
